/**
 * Страницы, которые должны быть добавлены в SiteMap
 * комментарии [START-PARSE] и [END-PARSE]
 * нужны скрипту по созданию путей рендеров.
 * Они указывают где начинать и где заканчивать брать пути для формирования рендеров
 * Внутренние комментарии // пропускаются скриптом
 * Скрипты сидят тут: \fast-angular\scripts
 */
export const seoRoutes: string[] = [
  /*[[START-PARSE]]*/
  '/',
  '/about',
  '/faq',
  '/tos',
  '/reviews',
  '/privacy-policy',
  '/responsible-play-policy',
  '/game/classic',
  '/game/classic/history',
  '/game/x50',
  '/game/double',
  '/game/crash',
  '/game/king',
  '/game/upgrader',
  '/game/slot',
  '/game/match-bets',
  '/game/cases',
  '/game/tower',
  '/game/hilo',
  '/game/case-battle',
  '/game/case-battle/new',
  '/game/case-battle/top',
  '/game/poggi',
  '/game/solitaire',
  '/history/crash',
  '/history/double',
  '/hell-case',
  '/key-drop',
  '/skin-club',
  '/store',
  '/seasons',
  '/seasons/quests',
  '/betting',
  // '/betting-rules' is intentionally absent: the page is auth-only (IsAuthGuard in footer.routes),
  // so it must not be prerendered, indexed, or listed in the sitemap.
  '/csgo-roll',
  '/farm-skins',
  '/events',
  '/events/wallachia-nights',
  '/provably-fair',
  '/tickets',
  '/anniversary',
  '/11years',
  '/fifa',
  '/free-coins',
  '/free-coins/hilo',
  '/free-coins/x50',
  '/free-coins/slot',
  '/free-coins/double',
  '/bug-bounty',
  '/aml-policy',
  '/anti-bribery-policy',
  '/bonuses/referral',
  '/refund-policy',
  '/account/referral/campaigns',
  '/account/main',
  '/login',
  '/partnership',
  '/north-pole',
  '/giveaways',
  /*[[END-PARSE]]*/
];
